import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronDown, Shield } from 'lucide-react'

const ApplicationsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)

  const applications = [
    { name: 'Cloud Chekr', href: 'https://cloud-chekr.modumatic.com', icon: Shield, external: true },
    // Add more applications here as needed
  ]

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        className="text-secondary hover:text-primary transition-colors duration-300 font-medium flex items-center gap-1"
      >
        Applications
        <ChevronDown 
          size={16} 
          className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.2 }}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
            className="absolute top-full left-0 mt-2 w-64 bg-background/95 backdrop-blur-md border border-gray-800 rounded-lg shadow-lg z-50"
          >
            <div className="py-2">
              {applications.map((app) => (
                <a
                  key={app.name}
                  href={app.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 px-4 py-3 text-secondary hover:text-primary hover:bg-primary/10 transition-colors duration-300"
                  onClick={() => setIsOpen(false)}
                >
                  <app.icon size={18} className="text-primary" />
                  <span className="font-medium">{app.name}</span>
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default ApplicationsDropdown
